import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Radio, Form } from 'antd';

import { Footer } from './Footer';
import { Header } from '../components/Header';
import { Internal } from '../Consulting/Internal';
import { Consultancy } from '../Consulting/Consultancy';
import { ErgonomicsSolutionTypeEnum } from '@/utils/enum';
import { InputNumberForm } from '../components/FormNumberInput';
import type { FormData } from '@/context/CalculatorReturnOfInvestment/types';
import { RadioButton } from './styles';
import * as S from '../../styles';

const { useWatch, useFormInstance } = Form;

export function Industry() {
	const fieldName: keyof FormData = 'industry';
	const form = useFormInstance<FormData>();
	const ergonomicsSolutions = useWatch([fieldName, 'ergonomics_solution_type'], form);

	return (
		<Row gutter={[0, 35]}>
			<Col span={24}>
				<Header title="Industry information" />
			</Col>
			<Col span={24}>
				<Row gutter={[20, 30]}>
					<Col xs={24} md={12} lg={8}>
						<S.RequiredFormItem
							labelCol={{ span: 24 }}
							name={[fieldName, 'number_of_units']}
							label={I18n.get('Number of units')}
							rules={[{ required: true, message: I18n.get('Please enter the number of units') }]}
						>
							<InputNumberForm placeholder={I18n.get('Enter the number of units')} min={0} />
						</S.RequiredFormItem>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<S.RequiredFormItem
							labelCol={{ span: 24 }}
							name={[fieldName, 'total_employees']}
							label={I18n.get('Total employees')}
							rules={[{ required: true, message: I18n.get('Please enter the total employees') }]}
						>
							<InputNumberForm placeholder={I18n.get('Enter the total employees')} min={0} />
						</S.RequiredFormItem>
					</Col>
					<Col xs={24} md={12} lg={8}>
						<S.RequiredFormItem
							labelCol={{ span: 24 }}
							name={[fieldName, 'total_workstations']}
							label={I18n.get('Total workstations')}
							rules={[{ required: true, message: I18n.get('Please enter the total workstations') }]}
						>
							<InputNumberForm placeholder={I18n.get('Enter the total workstations')} min={0} />
						</S.RequiredFormItem>
					</Col>
					<Col span={24}>
						<S.RequiredFormItem
							labelCol={{ span: 24 }}
							name={[fieldName, 'ergonomics_solution_type']}
							label={I18n.get('Ergonomic solution type')}
							rules={[{ required: true, message: I18n.get('Select the ergonomics solution type') }]}
						>
							<Radio.Group style={{ width: '100%' }}>
								<Row gutter={[20, 20]}>
									<Col xs={24} lg={12}>
										<RadioButton value={ErgonomicsSolutionTypeEnum.CONSULTANCY}>
											{I18n.get('External consultancy')}
										</RadioButton>
									</Col>
									<Col xs={24} lg={12}>
										<RadioButton value={ErgonomicsSolutionTypeEnum.INTERNAL}>
											{I18n.get('Internal ergonomics')}
										</RadioButton>
									</Col>
								</Row>
							</Radio.Group>
						</S.RequiredFormItem>
						{ergonomicsSolutions === ErgonomicsSolutionTypeEnum.CONSULTANCY && <Consultancy />}
						{ergonomicsSolutions === ErgonomicsSolutionTypeEnum.INTERNAL && <Internal />}
					</Col>
				</Row>
			</Col>
			<Col span={24}>
				<Footer />
			</Col>
		</Row>
	);
}
